export default "__VITE_ASSET__foqig$59__"